export const NodeTypes = Object.freeze({
    FORM: 'form',
    VERIFICATION: 'verification',
    LIVENESS: 'liveness',
    SELFIE: 'selfie',
    EMAIL_VERIFICATION: 'emailVerification',
    EID_VERIFICATION: 'eidVerification',
    PHONE_VERIFICATION: 'phoneVerification',
    ADDRESS_VERIFICATION: 'addressVerification',
    BANK_VERIFICATION: "bankVerification",
    PAYMENT_VERIFICATION: "paymentVerification",
    GEOLOCATION_VERIFICATON: "geolocationVerification",
    FILE_UPLOAD_KYC: 'otherKyc', //miscellaneousDocumentUpload
    FILE_UPLOAD: "documentVerification",
    CONDITION: 'condition',
    FINAL: 'final',
});
